import React from "react";

const PILLARS = [
    {
        kicker: "01 / DOUBLE-ENTRY",
        title: "Balanced by construction.",
        body: "Every rupee that moves posts to two accounts, in one atomic transaction. If debits don't equal credits, the entry doesn't save. Trial balance always ties.",
    },
    {
        kicker: "02 / GST + IRP + TDS",
        title: "Compliance, computed at the line.",
        body: "GST is calculated per invoice line, not stapled on at the end. TDS deducts from the vendor's default section. E-invoice IRN generates on save. GSTR-1, 3B and 2B auto-populate.",
    },
    {
        kicker: "03 / MULTI-CURRENCY",
        title: "USD, GBP, INR — one ledger.",
        body: "Every transaction stores its native amount, its base-currency amount, and the rate used. Realized FX gain/loss posts automatically on settlement. Unrealized revaluation runs at month-end.",
    },
];

export default function DepthOfEngine() {
    return (
        <section className="vy-dark vy-section" data-testid="landing-depth">
            <div className="vy-container" style={{ position: "relative", zIndex: 1 }}>
                <div className="vy-reveal" style={{ textAlign: "center", marginBottom: 48 }}>
                    <div className="vy-kicker">&gt; engine.spec --show</div>
                    <h2 className="vy-serif vy-h-section" style={{ fontSize: "2.8rem", marginTop: 10, color: "var(--vy-paper)" }}>
                        A serious engine. <span className="vy-serif-i" style={{ color: "var(--vy-gold)" }}>For serious books.</span>
                    </h2>
                    <p style={{ marginTop: 12, color: "rgba(246,242,235,0.7)", maxWidth: 680, margin: "12px auto 0", fontSize: 15, lineHeight: 1.6 }}>
                        Every rupee that moves posts to two accounts. GST is computed at the line, not stapled on
                        at the end. TDS deducts by section from the vendor&apos;s default. Your CA won&apos;t
                        rebuild the books at year-end.
                    </p>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 16, alignItems: "stretch" }} className="vy-grid-3">
                    {PILLARS.map((p, i) => (
                        <div
                            key={p.kicker}
                            className="vy-reveal"
                            data-vy-delay={(i + 1).toString()}
                            data-testid={"depth-card-" + i}
                            style={{
                                background: "var(--vy-paper)",
                                border: "1px solid rgba(166,138,86,0.35)",
                                padding: "36px 30px",
                                borderRadius: 2,
                                display: "flex",
                                flexDirection: "column",
                                gap: 14,
                                minHeight: 260,
                            }}
                        >
                            <div className="vy-kicker">{p.kicker}</div>
                            <h3
                                className="vy-serif"
                                style={{
                                    fontSize: 24,
                                    marginTop: 4,
                                    color: "var(--vy-navy)",
                                    lineHeight: 1.2,
                                }}
                            >
                                {p.title}
                            </h3>
                            <p
                                style={{
                                    marginTop: 4,
                                    fontSize: 14,
                                    color: "var(--vy-muted)",
                                    lineHeight: 1.6,
                                }}
                            >
                                {p.body}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
